/** What a fulfiller reads to recognize an order line: name, picture and printing. */
export interface OrderLineDisplay {
  name?: string;
  imageUrl?: string;
  collectionName?: string;
  printing?: string;
}

/**
 * The display fields out of an order line's snapshot. A withdrawal snapshots the drop-table entry
 * (`name`, `imageUrl`); a line migrated from boxed carries `image` and a `details` JSON string
 * with the printing. Like `readMarketplaceSnapshot`, a mistyped field is dropped, never thrown.
 */
export function readLineDisplay(snapshot: unknown): OrderLineDisplay {
  if (typeof snapshot !== "object" || snapshot === null || Array.isArray(snapshot)) return {};
  const fields = snapshot as Record<string, unknown>;
  return {
    name: text(fields.name),
    imageUrl: text(fields.imageUrl) ?? text(fields.image),
    collectionName: text(fields.collectionName),
    printing: text(readDetails(fields.details).printing),
  };
}

/** boxed stored `details` as a JSON string; a newer writer may store the object itself. */
function readDetails(details: unknown): Record<string, unknown> {
  if (typeof details === "string") {
    try {
      return readDetails(JSON.parse(details));
    } catch {
      return {};
    }
  }
  return typeof details === "object" && details !== null && !Array.isArray(details)
    ? (details as Record<string, unknown>)
    : {};
}

function text(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value : undefined;
}
